import React, { useState, useEffect } from 'react';
import { Modal, Avatar, Button, Tag, Row, Col, Card, Divider, Input, Form, Select, Switch, message, Popover, List } from 'antd';
import { EditOutlined, CloseOutlined, CheckOutlined, SaveOutlined, CheckCircleTwoTone, UserOutlined, PhoneOutlined, MailOutlined, BankOutlined, IdcardOutlined, TeamOutlined, CrownOutlined, DeleteOutlined, ExclamationCircleTwoTone, PlusOutlined, CommentOutlined } from '@ant-design/icons';
import './UserDetailsModal.scss';
import { DEFAULT_PROFILE_IMAGE, SUPER_ADMIN_API_URL } from '../../../../../constants';
import { GetCountries, GetState } from 'react-country-state-city';
import { useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../../../../app/store';
import TextArea from 'antd/es/input/TextArea';
import { useDispatch } from 'react-redux';
import { fetchNotesList, saveNotes } from '../../../../../features/users/usersSlice';
import { Toast } from 'react-toastify/dist/components';
import { toast } from 'react-toastify';


const { Option } = Select;

interface UserData {
  id: number;
  first_name: string;
  last_name: string;
  display_name: string;
  username: string;
  email: string;
  email_pref: number;
  pager_number: string;
  pager_pref: number;
  profile_pic: string;
  user_type: string;
  source_of_reg_request: string;
  approval_status: string;
  network_roles: number[];
  network_specialties: number[];
  practice_sites: Array<{
    name: string;
    phone_number_country_code: string;
    phone_number: string;
    position:string;
    country: { name: string; country_name_code: string };
    state: { name: string; country_name_code: string };
    city: { name: string; country_name_code: string };
    address_one: string;
    address_two: string;
    address_three: string;
  }>;
  medical_licenses: Array<{
    license_number: string;
    country: { name: string; country_name_code: string };
    issuing_state: { name: string; state_code: string };
    is_valid: boolean;
    validation_status: string;
    comment?: string;
  }>;
  contact_info: Array<{
    country_code: string;
    number: string;
    pref: number;
    number_type: string;
    number_status: string;
  }>;
  membership_plan: Array<{
    subscription_plan: {
      name: string;
      price: string;
      currency: string;
    };
  }>;
}

interface UserDetailsModalProps {
  fromMemberPage?: boolean
  isVisible: boolean;
  user: UserData | null;
  onClose: () => void;
  onAccept: (user: UserData, isApprove: boolean, Reason?: string) => void;
  onReject: (user: UserData, isApprove: boolean, Reason?: string) => void;
  currentTab?: string;
  onEdit: (user: UserData) => void;
  onDelete: (user: UserData) => void;
  onVerifyLicense?: (user: UserData, licenseIndex: number) => void;
  onRejectLicense?: (user: UserData, licenseIndex: number, reason: string) => void;
  onEditLicense?: (user: UserData, licenseIndex: number, updatedLicense: UserData['medical_licenses'][number]) => void;
  onSaveLicense?: (user: UserData, licenseIndex: number, updatedLicense: UserData['medical_licenses'][number]) => void;
  isLicenseActionLoading?: boolean;
  isEditLicenseLoading?: boolean;
}

export const UserDetailsModal: React.FC<UserDetailsModalProps> = ({
  fromMemberPage,
  isVisible,
  user,
  onClose,
  onAccept,
  onReject,
  currentTab,
  onEdit,
  onDelete,
  onVerifyLicense,
  onRejectLicense,
  onEditLicense,
  onSaveLicense,
  isLicenseActionLoading = false,
  isEditLicenseLoading = false
}) => {
console.log(user,"useruser")

  // Every ON user is created with approval_status "incomplete"
  // (on_user_manager.py create_user writes it unconditionally, not only for
  // website self-registration) and nothing promotes it to "pending" on its own.
  // Gating these actions on the "approval" tab alone therefore stranded every
  // self-registered signup: it could only ever appear under "New Requests",
  // which had no action that could move it anywhere. The backend already
  // handles the incomplete -> pending/approved transition -- on_user_approval
  // promotes an incomplete record to its membership's validation_status -- so
  // the same actions simply need to be reachable from that tab.
  const canActOnRequest = currentTab === 'approval' || currentTab === 'new';
  // A record still being reviewed may need its details corrected before it can
  // pass verification, so editing is available there too.
  const canEditProfile = currentTab === 'approved' || currentTab === 'active'
    || currentTab === 'new';

  const [rejectionModalVisible, setRejectionModalVisible] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [form] = Form.useForm();
 
const dispatch = useDispatch<appDispatch>();

  // License action loading states
  const [verifyingLicenseIndex, setVerifyingLicenseIndex] = useState<number | null>(null);
  const [rejectingLicenseIndex, setRejectingLicenseIndex] = useState<number | null>(null);

  // License rejection modal state
  const [licenseRejectionModalVisible, setLicenseRejectionModalVisible] = useState(false);
  const [licenseRejectionReason, setLicenseRejectionReason] = useState('');
  const [licenseRejectionForm] = Form.useForm();
  const [pendingLicenseRejection, setPendingLicenseRejection] = useState<{ user: UserData, licenseIndex: number } | null>(null);

  // Inline license editing state
  const [editingLicenseIndex, setEditingLicenseIndex] = useState<number | null>(null);
  const [editedLicense, setEditedLicense] = useState<any | null>(null);
  const [countriesList, setCountriesList] = useState<any[]>([]);
  const [statesForEditing, setStatesForEditing] = useState<any[]>([]);
  const [note, setNote] = useState("");
  const [notes, setNotes] = useState<string[]>([]);

const notesListData = useSelector(
  (state: RootState) => state.users.fetchNotesList.fetchNotesListData
) || [];
console.log(notesListData,"notesListData")
  useEffect(() => {
    const thunkArgs:any = {}
    GetCountries().then((result: any) => setCountriesList(result));
    dispatch(fetchNotesList(thunkArgs))
  }, []);

  // Clear loading states when global loading state changes
  useEffect(() => {
    if (!isLicenseActionLoading) {
      setVerifyingLicenseIndex(null);
      setRejectingLicenseIndex(null);
    }
  }, [isLicenseActionLoading]);


  const handleAddNote = () => {
      const thunkArgs = {}
    if (note.trim() !== "") {
      setNotes([note, ...notes]); // add new note at top
      setNote(""); // clear input
      const payload={
        on_user_id:user?.id,
        note:note
      }
  dispatch(saveNotes(payload))
  .unwrap()
  .then(async (res) => {
    toast.success("Notes saved successfully");
    const thunkArgs : any={}
await dispatch(fetchNotesList({ id: String(user?.id ?? "") }));
    // handle success UI (toast, navigate, etc.)
  })
  .catch((err) => {
    console.error("Error saving notes", err);
    // handle error UI
  });
    }
  };

  const handleRejectClick = () => {
    setRejectionModalVisible(true);
  };

  const handleRejectSubmit = () => {
    form.validateFields().then(() => {
      if (user) {
        onReject(user, false, rejectionReason);
        setRejectionModalVisible(false);
        setRejectionReason('');
        form.resetFields();
      }
    });
  };

  const handleRejectCancel = () => {
    setRejectionModalVisible(false);
    setRejectionReason('');
    form.resetFields();
  };

  const handleLicenseVerify = (idx: number) => {
    if (user && onVerifyLicense) {
      setVerifyingLicenseIndex(idx);
      // Pass a cloned user with full licenses to avoid dropping others
      const clonedUser: UserData = {
        ...user,
        medical_licenses: user.medical_licenses.map((lic, i) => ({ ...lic }))
      };
      onVerifyLicense(clonedUser, idx);
    }
  };

  const handleLicenseRejectClick = (idx: number) => {
    if (user && onRejectLicense) {
      // Stash a cloned user with full licenses
      const clonedUser: UserData = {
        ...user,
        medical_licenses: user.medical_licenses.map((lic) => ({ ...lic }))
      };
      setPendingLicenseRejection({ user: clonedUser, licenseIndex: idx });
      setLicenseRejectionModalVisible(true);
    }
  };

  const handleLicenseRejectCancel = () => {
    setLicenseRejectionModalVisible(false);
    setLicenseRejectionReason('');
    setPendingLicenseRejection(null);
    licenseRejectionForm.resetFields();
  };

  const handleLicenseRejectSubmit = () => {
    licenseRejectionForm.validateFields().then(() => {
      if (pendingLicenseRejection && onRejectLicense) {
        setRejectingLicenseIndex(pendingLicenseRejection.licenseIndex);
        onRejectLicense(pendingLicenseRejection.user, pendingLicenseRejection.licenseIndex, licenseRejectionReason);
        setLicenseRejectionModalVisible(false);
        setLicenseRejectionReason('');
        setPendingLicenseRejection(null);
        licenseRejectionForm.resetFields();
      }
    });
  };

  const handleLicenseEditClick = (idx: number) => {
    if (!user) return;
    setEditingLicenseIndex(idx);
    const current = user.medical_licenses[idx];
    setEditedLicense({ ...current });
    // Preload states for current country
    const iso2 = current?.country?.country_name_code;
    if (iso2) {
      const countryObj = countriesList.find(c => c.iso2 === iso2);
      if (countryObj) {
        GetState(countryObj.id).then((result: any) => {
          setStatesForEditing(result);
          // Ensure the state is properly bound by checking if current state exists in loaded states
          if (current?.issuing_state?.name) {
            const existingState = result.find((s: any) =>
              s.state_code === current.issuing_state.state_code ||
              s.name === current.issuing_state.name
            );
            if (existingState) {
              setEditedLicense((prev: any) => ({
                ...prev,
                issuing_state: {
                  ...prev.issuing_state,
                }
              }));
            }
          }
        });
      } else {
        setStatesForEditing([]);
      }
    } else {
      setStatesForEditing([]);
    }
  };

  const handleLicenseEditCancel = () => {
    setEditingLicenseIndex(null);
    setEditedLicense(null);
  };

  const handleLicenseFieldChange = (field: string, value: any) => {
    setEditedLicense((prev: any) => {
      if (!prev) return prev;
      if (field === 'country.name') {
        return { ...prev, country: { ...prev.country, name: value } };
      }
      if (field === 'issuing_state.name') {
        return { ...prev, issuing_state: { ...prev.issuing_state, name: value } };
      }
      return { ...prev, [field]: value };
    });
  };

  const handleLicenseEditSave = () => {
    if (user && editingLicenseIndex !== null && editedLicense && onSaveLicense) {
      // Call the parent save function with full licenses preserved
      const clonedUser: UserData = {
        ...user,
        medical_licenses: user.medical_licenses.map((lic) => ({ ...lic }))
      };
      onSaveLicense(clonedUser, editingLicenseIndex, editedLicense);
      // Reset the editing state
      setEditingLicenseIndex(null);
      setEditedLicense(null);
    }
  };

  const handleEditedLicenseCountryChange = (countryId: number, option: any) => {
    const iso2: string = option?.props?.['data-iso2'] || '';
    const name: string = option?.children || '';
    setEditedLicense((prev: any) => ({
      ...prev,
      country: {
        ...(prev?.country || {}),
        name,
        country_name_code: iso2,
      },
      issuing_state: {
        ...(prev?.issuing_state || {}),
        name: '',
        state_code: '',
      },
    }));
    if (countryId) {
      GetState(countryId).then((result: any) => setStatesForEditing(result));
    } else {
      setStatesForEditing([]);
    }
  };

  const handleEditedLicenseStateChange = (stateId: number, option: any) => {
    const stateCode: string = option?.props?.['data-statecode'] || '';
    const name: string = option?.children || '';
    setEditedLicense((prev: any) => ({
      ...prev,
      issuing_state: {
        ...(prev?.issuing_state || {}),
        name,
        state_code: stateCode,
      },
    }));
  };

  // const displayImage = (imageUrl: string | undefined) => {
  //   if (!imageUrl || imageUrl.trim() === "") {
  //     return DEFAULT_PROFILE_IMAGE;
  //   }
  //   return `${SUPER_ADMIN_API_URL}${imageUrl}`;
  // }

  return (
    <Modal
      open={isVisible}
      onCancel={() => {
        handleLicenseEditCancel()
        onClose()
      }}
      footer={null}
      width={"75%"}
      className="user-details-modal fixed-height-modal"
      centered={true}
      bodyStyle={{
        padding: '24px',
        background: 'var(--modal-background-color)',
        height: '650px',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {user && (
        <div className="user-details-content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="modal-scroll-content" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: ".75rem", minHeight: 0 }}>
            {/* Profile Summary Section */}
            <Row gutter={[24, 24]} className="profile-section">
              <Col  sm={24} md={24} lg={12} xl={12}>
                <Card
                  className="profile-card"
                  bodyStyle={{ padding: '24px' }}
                >
                  <div className="profile-header">
                    <Avatar
                      size={100}
                      src={user.profile_pic ?? DEFAULT_PROFILE_IMAGE}
                      alt={user.display_name}
                      className="profile-avatar"
                    />
                    <div className="profile-info">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <h2 className="profile-name">
                          {user?.display_name}
                        </h2>
                        <div className="profile-actions" style={{ display: 'flex', gap: '8px' }}>
                          {canEditProfile &&
                            <Button
                              onClick={() => onEdit(user)}
                              icon={<EditOutlined />}
                              shape="circle"
                              size="middle"
                              className="edit-btn"
                              title="Edit Profile"
                              style={{
                                background: 'transparent'
                              }}
                            />
                          }
                          {/* {currentTab !== 'approval' && <Button 
                            onClick={() => onDelete(user)}
                            icon={<DeleteOutlined/>}
                            shape="circle"
                            size="middle"
                            className="delete-btn"
                            title="Delete User"
                            style={{ 
                              background: 'transparent'
                            }}
                          />} */}
                        </div>
                      </div>
                      <Row gutter={[24, 12]}>
                        <Col sm={24} md={24} lg={8} xl={8} >
                          <div className="info-label">Username</div>
                          <div className="info-value">{user.username}</div>
                        </Col>
                        <Col sm={24} md={24} lg={8} xl={8}>
                          <div className="info-label">User Type</div>
                          <div className="info-value">{user.user_type}</div>
                        </Col>
                        <Col sm={24} md={24} lg={8} xl={8}>
                          <div className="info-label">Status</div>
                          <Tag
                            color={user.approval_status === 'pending' ? '#a16b0e' : user.approval_status === 'approved' ? '#4554fa' : '#d93a45'}
                            className="status-tag"
                          >
                            {user.approval_status}
                          </Tag>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Card>
              </Col>

              {/* Membership Plan */}
              <Col sm={24} md={24} lg={12} xl={12}>
                {user.membership_plan && user.membership_plan.length > 0 && (
                  <Card
                    title={
                      <div className="card-title" style={{ color: 'var(--common-black-white)', display: "flex", alignItems: "center", gap: "8px" }}>
                        <CrownOutlined className="card-icon membership-icon" />
                        Membership Plan
                      </div>
                    }
                    size="small"
                    className="info-card"
                    style={{
                      background: 'var(--common-dashboard-card-background-color)',
                      minHeight: '9.5rem',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                    headStyle={{ background: 'var(--country-dropdown-hover)', color: 'white', borderBottom: '1px solid var(--border-color-primary),' }}
                    bodyStyle={{
                      padding: '20px',
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center'
                    }}
                  >
                    <Row gutter={[24, 12]}>
                      <Col span={12}>
                        <div className="info-item">
                          <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>Plan Name</div>
                          <div className="info-value">
                            <Tag color="#4554fa" className="plan-tag">
                              {user.membership_plan[0].subscription_plan.name}
                            </Tag>
                          </div>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="info-item">
                          <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>Price</div>
                          <div className="info-value price-value" style={{ color: 'var(--font-color-primary)' }}>
                            {user.membership_plan[0].subscription_plan.price} {user.membership_plan[0].subscription_plan.currency}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                )}
              </Col>
            </Row>

            {/* Main Information Grid */}
            <Row gutter={[24, 24]} className="info-grid">
              {/* License Information */}
              <Col sm={24} md={24} lg={12} xl={12}>
                {user.medical_licenses && user.medical_licenses.length > 0 && (
                  <Card
                    title={
                      <div className="card-title">
                        <IdcardOutlined className="card-icon license-icon" />
                        Medical License Information
                      </div>
                    }
                    size="small"
                    className="info-card"
                    headStyle={{ background: 'var(--country-dropdown-hover)', color: 'white' }}
                    bodyStyle={{ padding: '20px' }}
                  >
                    {user.medical_licenses.map((license, idx) => (
                      <React.Fragment key={idx}>
                        {idx > 0 && <Divider style={{ margin: '16px 0' }} />}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '8px',
                          marginBottom: '12px'
                        }}>
                                                     <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                             <div style={{
                               fontWeight: 'bold',
                               color: 'var(--font-color-primary)',
                               fontSize: '14px'
                             }}>
                               {user.medical_licenses.length > 1 ? `License ${idx + 1}` : 'License'}
                             </div>
                             {(license?.is_valid || license?.validation_status === 'approved') ? (
                               <CheckCircleTwoTone twoToneColor="#1a865f" />
                             ) : license?.comment ? (
                               <Popover
                                 content={
                                   <div>
                                     <strong>Rejection Reason:</strong>
                                     <br />
                                     {license.comment}
                                   </div>
                                 }
                                 title="License Rejected"
                                 trigger="hover"
                               >
                                   <ExclamationCircleTwoTone twoToneColor="#d93a45" />
                                 </Popover>
                             ) : (
                               <ExclamationCircleTwoTone twoToneColor="#a16b0e" />
                             )}
                           </div>
                          {editingLicenseIndex === idx ? (
                            <div style={{ display: 'flex', gap: '8px' }}>
                              <Button
                                type="primary"
                                title="Save license"
                                icon={<SaveOutlined />}
                                onClick={handleLicenseEditSave}
                                loading={isEditLicenseLoading}
                                disabled={isEditLicenseLoading}
                              />
                              <Button
                                title="Cancel editing"
                                icon={<CloseOutlined />}
                                onClick={handleLicenseEditCancel}
                              />
                            </div>
                          ) : canActOnRequest && !(license?.is_valid || license?.validation_status === 'approved')  &&!license?.comment && (
                            <div style={{ display: 'flex', gap: '8px' }}>
                              <Button
                                type="text"
                                title="Verify license"
                                icon={<CheckOutlined style={{ color: '#4554fa' }} />}
                                onClick={() => handleLicenseVerify(idx)}
                                disabled={!onVerifyLicense || verifyingLicenseIndex === idx || rejectingLicenseIndex === idx || isEditLicenseLoading}
                                loading={verifyingLicenseIndex === idx}
                                className='verify-license-btn'
                              />
                              <Button
                                type="text"
                                title="Reject license"
                                danger
                                icon={<CloseOutlined />}
                                onClick={() => handleLicenseRejectClick(idx)}
                                disabled={!onRejectLicense || verifyingLicenseIndex === idx || rejectingLicenseIndex === idx || isEditLicenseLoading}
                                loading={rejectingLicenseIndex === idx}
                                className='reject-license-btn'
                              />
                              <Button
                                type="text"
                                title="Edit license"
                                icon={<EditOutlined />}
                                onClick={() => handleLicenseEditClick(idx)}
                                disabled={!onEditLicense || verifyingLicenseIndex === idx || rejectingLicenseIndex === idx || isEditLicenseLoading}
                                className='edit-license-btn'
                              />
                            </div>
                          )}
                        </div>
                        {editingLicenseIndex === idx ? (
                          <>
                            <Row gutter={[16, 12]}>
                              <Col span={8}>
                                <div className="info-item">
                                  <div className="info-label">License Number</div>
                                  <Input
                                    value={editedLicense?.license_number}
                                    onChange={(e) => handleLicenseFieldChange('license_number', e.target.value)}
                                  />
                                </div>
                              </Col>
                              <Col span={8}>
                                <div className="info-item">
                                  <div className="info-label">Country</div>
                                  <Select
                                    placeholder="Select country"
                                    value={
                                      countriesList.find(c => c.iso2 === editedLicense?.country?.country_name_code)?.id
                                    }
                                    onChange={(value, option) => handleEditedLicenseCountryChange(value as number, option)}
                                    showSearch
                                    optionFilterProp="children"
                                    style={{ width: '100%' }}
                                  >
                                    {countriesList.map(country => (
                                      <Option value={country.id} key={country.id} data-iso2={country.iso2}>{country.name}</Option>
                                    ))}
                                  </Select>
                                </div>
                              </Col>
                              <Col span={8}>
                                <div className="info-item">
                                  <div className="info-label">Issuing State</div>
                                  <Select
                                    placeholder="Select state"
                                    value={
                                      (() => {
                                        const state = statesForEditing.find((s: any) =>
                                          s.state_code === editedLicense?.issuing_state?.state_code ||
                                          s.name === editedLicense?.issuing_state?.name
                                        );
                                        return state?.id || undefined;
                                      })()
                                    }
                                    onChange={(value, option) => handleEditedLicenseStateChange(value as number, option)}
                                    showSearch
                                    optionFilterProp="children"
                                    style={{ width: '100%' }}
                                    disabled={!editedLicense?.country?.country_name_code}
                                  >
                                    {statesForEditing.map((state: any) => (
                                      <Option value={state.id} key={state.id} data-statecode={state.state_code}>{state.name}</Option>
                                    ))}
                                  </Select>
                                </div>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Row gutter={[16, 12]}>
                            <Col  sm={24} md={24} lg={8} xl={8}>
                              <div className="info-item">
                                <div className="info-label">License Number</div>
                                <div className="info-value">{license.license_number}</div>
                              </div>
                            </Col>
                            <Col sm={24} md={24} lg={8} xl={8}>
                              <div className="info-item">
                                <div className="info-label">Country</div>
                                <div className="info-value">{license.country.name}</div>
                              </div>
                            </Col>
                            <Col sm={24} md={24} lg={8} xl={8}>
                              <div className="info-item">
                                <div className="info-label">Issuing State</div>
                                <div className="info-value">{license.issuing_state.name}</div>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </React.Fragment>
                    ))}
                  </Card>
                )}
              </Col>

              {/* Role and Specialty */}
              <Col sm={24} md={24} lg={12} xl={12}>
                <Card
                  title={
                    <div className="card-title">
                      <TeamOutlined className="card-icon role-icon" />
                      Role and Specialty
                    </div>
                  }
                  size="small"
                  className="info-card"
                  headStyle={{ background: 'var(--country-dropdown-hover)', color: 'white' }}
                  bodyStyle={{ padding: '20px' }}
                >
                  <Row gutter={[16, 12]}>
                    <Col sm={24} md={24} lg={12} xl={12}>
                      <div className="info-item">
                        <div className="info-label">Network Roles</div>
                        <div className="info-value">
                          {
                            user.network_roles?.map((role: any) => {
                              return (
                                <Tag color="#4554fa" className="role-tag">
                                  {role?.name}
                                </Tag>
                              )
                            })
                          }
                        </div>
                      </div>
                    </Col>
                    <Col sm={24} md={24} lg={12} xl={12}>
                      <div className="info-item">
                        <div className="info-label">Network Specialties</div>
                        <div className="info-value" style={{ width: "100%", gap: ".5rem" }}>

                          {user.network_specialties.map((specialty: any) => {
                            return (
                              <Tag color="#4554fa" className="role-tag">
                                {specialty?.name}
                              </Tag>
                            )
                          })}

                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>

            {/* Second Row */}
            <Row gutter={[24, 24]} className="info-grid">
              {/* Practice Information */}
              <Col sm={24} md={24} lg={12} xl={12}>
                {user.practice_sites && user.practice_sites.length > 0 && (
                  <Card
                    title={
                      <div className="card-title">
                        <BankOutlined className="card-icon practice-icon" />
                        Practice Information
                      </div>
                    }
                    size="small"
                    className="info-card"
                    headStyle={{ background: 'var(--country-dropdown-hover)', color: 'white' }}
                    bodyStyle={{ padding: '20px' }}
                  >
                    {user.practice_sites.map((practiceSite, index) => (
                      <div key={index}>
                        {index > 0 && <Divider style={{ margin: '16px 0' }} />}
                        {user.practice_sites.length > 1 && (
                          <div style={{
                            fontWeight: 'bold',
                            color: 'var(--font-color-primary)',
                            marginBottom: '12px',
                            fontSize: '14px'
                          }}>
                            Practice Site {index + 1}
                          </div>
                        )}
                        <Row gutter={[16, 12]}>
                          <Col sm={24} md={24} lg={8} xl={8}>
                            <div className="info-item">
                              <div className="info-label">Practice Name</div>
                              <div className="info-value">{practiceSite.name}</div>
                            </div>
                          </Col>

                            <Col sm={24} md={24} lg={8} xl={8}>
                            <div className="info-item">
                              <div className="info-label">Practice Position</div>
                              <div className="info-value">{practiceSite.position}</div>
                            </div>
                          </Col>
                          <Col sm={24} md={24} lg={8} xl={8}>
                            <div className="info-item">
                              <div className="info-label">Practice Phone</div>
                              <div className="info-value">
                                {practiceSite.phone_number_country_code} {practiceSite.phone_number}
                              </div>
                            </div>
                          </Col>
                          <Col sm={24} md={24} lg={8} xl={8}>
                            <div className="info-item">
                              <div className="info-label">Address</div>
                              <div className="info-value">{practiceSite.address_one}</div>
                            </div>
                          </Col>
                          <Col sm={24} md={24} lg={8} xl={8}>
                            <div className="info-item">
                              <div className="info-label">Country</div>
                              <div className="info-value">{practiceSite.country.name}</div>
                            </div>
                          </Col>
                          <Col sm={24} md={24} lg={8} xl={8}>
                            <div className="info-item">
                              <div className="info-label">State</div>
                              <div className="info-value">{practiceSite.state.name}</div>
                            </div>
                          </Col>
                          <Col sm={24} md={24} lg={8} xl={8}>
                            <div className="info-item">
                              <div className="info-label">City</div>
                              <div className="info-value">{practiceSite.city.name}</div>
                            </div>
                          </Col>
                          {practiceSite.address_two && (
                            <Col sm={24} md={24} lg={8} xl={8}>
                              <div className="info-item">
                                <div className="info-label">Address 2</div>
                                <div className="info-value">{practiceSite.address_two}</div>
                              </div>
                            </Col>
                          )}
                          {practiceSite.address_three && (
                            <Col sm={24} md={24} lg={8} xl={8}>
                              <div className="info-item">
                                <div className="info-label">Address 3</div>
                                <div className="info-value">{practiceSite.address_three}</div>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>
                    ))}
                  </Card>
                )}
              </Col>
              {/* Contact Information */}
              <Col sm={24} md={24} lg={12} xl={12}>
                <Card
                  title={
                    <div className="card-title">
                      <PhoneOutlined className="card-icon contact-icon" />
                      Contact Information
                    </div>
                  }
                  size="small"
                  className="info-card"
                  headStyle={{ background: 'var(--country-dropdown-hover)', color: 'white' }}
                  bodyStyle={{ padding: '20px' }}
                >
                  <Row gutter={[16, 12]}>
                    <Col sm={24} md={24} lg={12} xl={12}>
                      <div className="info-item">
                        <div className="info-label">Email</div>
                        <div className="info-value">{user.email}</div>
                      </div>
                    </Col>
                    <Col sm={24} md={24} lg={12} xl={12}>
                      <div className="info-item">
                        <div className="info-label">Email Preference</div>
                        <div className="info-value">{user.email_pref}</div>
                      </div>
                    </Col>
                    <Col sm={24} md={24} lg={12} xl={12}>
                      <div className="info-item">
                        <div className="info-label">Pager Number</div>
                        <div className="info-value">{user.pager_number}</div>
                      </div>
                    </Col>
                    <Col sm={24} md={24} lg={12} xl={12}>
                      <div className="info-item">
                        <div className="info-label">Pager Preference</div>
                        <div className="info-value">{user.pager_pref}</div>
                      </div>
                    </Col>
                    {user.contact_info && user.contact_info.length > 0 && (
                      <>
                        {/* Primary Contact */}
                        {user.contact_info.find(contact => contact.number_status === 'primary') && (
                          <>
                            <Col sm={24} md={24} lg={12} xl={12}>
                              <div className="info-item">
                                <div className="info-label">Primary Phone Number</div>
                                <div className="info-value">
                                  {user.contact_info.find(contact => contact.number_status === 'primary')?.country_code} {user.contact_info.find(contact => contact.number_status === 'primary')?.number}
                                </div>
                              </div>
                            </Col>
                            <Col sm={24} md={24} lg={12} xl={12}>
                              <div className="info-item">
                                <div className="info-label">Primary Phone Number Preference</div>
                                <div className="info-value">{user.contact_info.find(contact => contact.number_status === 'primary')?.pref}</div>
                              </div>
                            </Col>
                          </>
                        )}
                        {/* Secondary Contact */}
                        {user.contact_info.find(contact => contact.number_status === 'secondary') && (
                          <>
                            <Col sm={24} md={24} lg={12} xl={12}>
                              <div className="info-item">
                                <div className="info-label">Secondary Phone Number</div>
                                <div className="info-value">
                                  {user.contact_info.find(contact => contact.number_status === 'secondary')?.country_code} {user.contact_info.find(contact => contact.number_status === 'secondary')?.number}
                                </div>
                              </div>
                            </Col>
                            <Col sm={24} md={24} lg={12} xl={12}>
                              <div className="info-item">
                                <div className="info-label">Secondary Phone Number Preference</div>
                                <div className="info-value">{user.contact_info.find(contact => contact.number_status === 'secondary')?.pref}</div>
                              </div>
                            </Col>

                          </>
                        )}
                      </>
                    )}
                  </Row>
                </Card>
              </Col>

              <Col sm={24} md={24} lg={12} xl={12}>
  <Card
    title={
      <div
        className="card-title"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>
          <CommentOutlined
            className="card-icon contact-icon"
            style={{ marginRight: 8 }}
          />
          Notes
        </span>
        <Button
          size="small"
          type="primary"
          shape="circle"
          icon={<PlusOutlined size={10} />}
          onClick={handleAddNote}
        />
      </div>
    }
    size="small"
    className="info-card"
    headStyle={{
      background: "var(--country-dropdown-hover)",
      color: "white",
    }}
    bodyStyle={{ padding: "20px" }}
  >
    <Row gutter={[16, 12]}>
      <TextArea
        placeholder="Please add your notes here"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        rows={3}
      />
    </Row>

    {/* Notes list */}
    <div
      style={{
        marginTop: 16,
        maxHeight: 150, // adjust as needed
        overflowY: "auto", // always enable scrolling if overflow
        paddingRight: 4,
      }}
    >
      <List
        dataSource={notesListData}
        renderItem={(item: any) => (
          <Card
            key={item.id}
            size="small"
            style={{
              marginBottom: 8,
              background: "#3e4348",
              color: "#fff",
            }}
          >
            <div>
              {item.note && item.note !== "{}" ? (
                item.note
              ) : (
                <i style={{ color: "#95989d" }}>Empty note</i>
              )}
            </div>
            <small style={{ color: "#c7cace" }}>
              {new Date(item.created_at).toLocaleString()}
            </small>
          </Card>
        )}
      />
    </div>
  </Card>
</Col>
            </Row>
          </div>
          {/* Footer Actions */}
          {canActOnRequest && (
            <div className="modal-footer">
              <Button
                danger
                size="large"
                onClick={handleRejectClick}
                className="reject-btn"
              >
                Reject
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={() => onAccept(user, true)}
                className="accept-btn"
              >
                Accept
              </Button>
            </div>
          )}
        </div>
      )}

      {/* Rejection Reason Modal */}
      <Modal
        title="Rejection Reason"
        open={rejectionModalVisible}
        onCancel={handleRejectCancel}
        centered={true}
        footer={[
          <Button key="cancel" onClick={handleRejectCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            danger
            onClick={handleRejectSubmit}
            disabled={!rejectionReason.trim()}
          >
            Reject Request
          </Button>
        ]}
        width={500}
        closable={false}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="rejectionReason"
            rules={[
              { required: true, message: 'Please enter a rejection reason' },
              { min: 10, message: 'Rejection reason must be at least 10 characters long' }
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Enter the reason for rejecting this user..."
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              maxLength={500}
              showCount
              className='rejection-input'
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* License Rejection Reason Modal */}
      <Modal
        title="License Rejection Reason"
        open={licenseRejectionModalVisible}
        onCancel={handleLicenseRejectCancel}
        centered={true}
        footer={[
          <Button key="cancel" onClick={handleLicenseRejectCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            danger
            onClick={handleLicenseRejectSubmit}
            disabled={!licenseRejectionReason.trim()}
          >
            Reject License
          </Button>
        ]}
        width={500}
        closable={false}
      >
        <Form form={licenseRejectionForm} layout="vertical">
          <Form.Item
            label="Please provide a reason for rejecting this license"
            name="licenseRejectionReason"
            rules={[
              { required: true, message: 'Please enter a rejection reason' },
              { min: 10, message: 'Rejection reason must be at least 10 characters long' }
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Enter the reason for rejecting this license..."
              value={licenseRejectionReason}
              onChange={(e) => setLicenseRejectionReason(e.target.value)}
              maxLength={500}
              showCount
              className='license-rejection-input'
            />
          </Form.Item>
        </Form>
      </Modal>


    </Modal>
  );
}; 